module.exports = __webpack_public_path__ + "media/images/icons/material/minus-686d0e9d4005d913b138af19533d99c6.svg";